module.exports = __webpack_public_path__ + "static/media/ic_error_v3.44aaf602.svg";